export default __webpack_public_path__ + "static/media/video-icon.ed89deba.svg";